import Section, { SubSection } from './Section'
import { t, tStr } from '@utils/lang'

const ByTexans = () => (
  <Section>
    <SubSection img={<img src="/images/byTexans.jpg" alt="" />} title={tStr('byTexansTitle_s')} flipSides>
      {t('byTexansBody_s')}
    </SubSection>
  </Section>
)

export default ByTexans
